import { getRoutes } from '@ui-framework/index';
import AuthorizationWrapper, {
  authFnAllowOnlySA,
} from '@product-framework/components/AuthorizationWrapper';
import ServiceJobEdit from './pages/edit/index';
import ServiceJobDispatch from './pages/dispatch';
import ServiceJobPreRegister from './pages/preregister/index';
import ServiceJobRegister from './pages/register/index';
import ServiceJobList from './pages/list/index';
import ServiceJobMap from './pages/map/index';
import ServiceJobClaim from './pages/claims/index';
import ServiceJobAlert from './pages/alerts/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import {
  ServiceJobEditFormStore,
  ServiceJobListStore,
  ServiceJobSearchFormStore,
} from './store';

const Pages = ProtectedRoute => ({
  ServiceJobDispatch: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobDispatch}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySA],
      }}
    />
  ),
  ServiceJobMap: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobMap}
      AuthorizationWrapper={AuthorizationWrapper}
      AuthorizationWrapperProps={{
        authorizationFn: [authFnAllowOnlySA],
      }}
    />
  ),
  ServiceJobEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobEdit}
    />
  ),
  ServiceJobPreRegister: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobPreRegister}
    />
  ),
  ServiceJobRegister: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobRegister}
    />
  ),
  ServiceJobList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobList}
    />
  ),
  ServiceJobClaim: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobClaim}
    />
  ),
  ServiceJobAlert: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceJobAlert}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { servicejobEditFormStore: new ServiceJobEditFormStore(rootStore) },
  { servicejobListStore: new ServiceJobListStore(rootStore) },
  { servicejobSearchFormStore: new ServiceJobSearchFormStore(rootStore) },
];

export {
  ServiceJobEdit,
  ServiceJobPreRegister,
  ServiceJobRegister,
  ServiceJobList,
  routes,
  stores,
};
